module.exports = __webpack_public_path__ + "assets/myKitchen final-01.png";